// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project-import
import UserAvatar from './UserAvatar';

interface Props {
  loading: boolean;
  selected: any;
  user: any;
  handleDrawerOpen: () => void;
}

// ==============================|| CHAT HEADER ||============================== //

export default function ChatHeader({ loading, user, handleDrawerOpen, selected }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ pl: 2 }}>
      <>
          <UserAvatar
            user={{
              online_status: 'available',
              avatar: 'available',
              name: "rak"
            }}
          />
          <Stack>
            <Typography variant="subtitle1">{selected ? selected?.name : "Create Processes"}</Typography>
          </Stack>
      </>
    </Stack>
  );
}
